<template lang="pug">
.help-wrapper
  v-btn.white--text(flat, icon, @click.native.stop="_openDialog")
    v-icon.left.mr-1(dark) help
  //- ヘルプダイアログ
  v-dialog.theme--white(
    v-show="openDialog",
    v-model="openDialog",
    scrollable,
    persistent
  )
    v-card.white.helpDialogContent
      v-card-title.headline
        v-icon(color="green") help
        span.ml-2 {{ pageTitle }}
      v-divider
      v-card-text.teal.lighten-5.text-xs-center(v-if="page === 1")
        p 『<a href="http://nigechizu.com" target="_new">逃げ地図</a>』は、<b class="pink--text">避難時間が目に見える</b>防災地図ツールです。
        p 逃げシルベを使って、<b>デジタル逃げ地図</b>を作成してみましょう！
        v-img.elevation-4(:src="getImg('help-screen.jpg')")
      v-card-text.teal.lighten-5(v-if="page === 2")
        v-timeline(dense, clipped)
          v-timeline-item(icon="search", color="warning", fill-dot)
            v-card.elevation-4
              v-card-text まずは<b>地図を自由に動かして</b>、あなたの地域を探してみましょう。
          v-timeline-item(icon="map", color="warning", fill-dot)
            v-card.elevation-4
              v-card-text
                v-chip.darken--2(label, color="green", text-color="white")
                  v-icon(left) map
                  span 地図
                span や
                v-chip.darken--2(label, color="green", text-color="white")
                  v-icon(left) category
                  span 情報
                span のボタンを押して、<b>地図の見た目を変える</b>ことができます。
                v-img(:src="getImg('help-view.jpg')")
          v-timeline-item(icon="touch_app", color="warning", fill-dot)
            v-card.elevation-4
              v-card-text
                img.elevation-4.mx-2(:src="getImg('help-icon.jpg')")
                span は<b class="pink--text">避難場所アイコン</b>。タッチして、<b>逃げ道を周りに引きましょう</b>。
      //- v-card-text(v-if="page === 3")
      v-divider
      v-layout.row.wrap
        v-flex.xs12.md4.offset-md2
          v-stepper.elevation-0(v-model="page")
            v-stepper-header(style="height: auto;")
              template(v-for="n in steps")
                v-stepper-step.py-3.mx-3(
                  editable,
                  edit-icon="check",
                  :complete="page > n",
                  :key="`${n}-step`",
                  :step="n"
                )
                v-divider(v-if="n !== steps", :key="n")
        v-flex.xs12.md4.text-xs-right
          v-btn(
            color="success",
            @click.native="openDialog = false"
          ) 試してみる！

        //- v-btn.blue--text.darken-1(flat block @click.native="openDialog = false") 閉じる
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    pageTitle() {
      return ["『逃げシルベ』へようこそ！", "逃げ地図を作ろう", ""][
        this.page - 1
      ];
    },
  },
  methods: {
    moveStep(n, step) {
      if (n === this.steps) {
        this.page = 1;
      } else {
        this.page = n + step;
      }
    },
    getImg(img) {
      return require("./../../assets/img/" + img);
    },
    _openDialog() {
      this.page = 1;
      this.openDialog = true;
    },
  },
  watch: {
    steps(val) {
      if (val < this.page) this.page = val;
    },
  },
  data() {
    return {
      openDialog: false,
      page: 1,
      steps: 2,
    };
  },
  mounted() {
    this.openDialog = true;
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// public/pages/index/components/toolbar/helpDialog.vue